import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from 'owa-application/lib/components/App';
import getProjection from './getProjection';
import getProjectionRoot from './getProjectionRoot';
import ProjectionContext from '../context/ProjectionContext';

export default function renderProjection(tabId: string, content: JSX.Element) {
    const projection = getProjection(tabId);
    const root = getProjectionRoot(projection);

    if (root && !root.firstChild && content) {
        ReactDOM.render(
            <App renderHeader={renderHeader} underlay={projection.underlay}>
                <ProjectionContext.Provider value={projection.window}>
                    {content}
                </ProjectionContext.Provider>
            </App>,
            root
        );
    }
}

function renderHeader() {
    return null;
}
